import React, {useEffect, useState} from "react";
import ChildrensBookPublishedBook from "./ChildrensBookPublishedBook";
import {api,API_BASE} from "../api";
import {approvedReaderToPublishedBookProps} from "../utils/childrensBookApprovedEditionViewV1.mjs";

/* Render published data from the server, never the current editing draft.
 * The legacy Reader path remains compatible. If an approved snapshot is corrupt,
 * the backend must error, and this component must not fall back to draft data.
 */
export default function ChildrensBookApprovedEditionGateV1({projectId,...legacyProps}) {
  const protectionEnabled = process.env.REACT_APP_CHILDRENS_BOOK_APPROVED_EDITION_V1_ENABLED === "true";
  const [loaded,setLoaded]=useState(null);
  const [error,setError]=useState("");
  useEffect(()=>{
    let alive=true;
    setLoaded(null);setError("");
    if(!protectionEnabled||!projectId){setLoaded({legacy:true});return()=>{alive=false;};}
    api.getChildrensBookPublishedEdition(projectId).then(result=>{
      if (!alive)return;
      if(!result?.ok||!result.reader)throw Error("Published edition is unavailable");
      if(result.hasApprovedEdition===false){setLoaded({legacy:true});return;}
      const projected = approvedReaderToPublishedBookProps(result.reader,API_BASE);
      const safeAssets = Array.isArray(result.approvedAssets)
        ? result.approvedAssets.map(a=>({...a,publicUrl:
            a.publicUrl?.startsWith("/") ? `${API_BASE}${a.publicUrl}` : a.publicUrl}))
        : projected.childrensBookAssets;
      setLoaded({projectPlan:result.reviewPlan || projected.projectPlan,
        childrensBookAssets:safeAssets});
    }).catch(err=>{
      if(!alive)return;
      // Failed lookup is never evidence that a mutable legacy draft is safe.
      setError(err?.message||"Published edition unavailable");
    });
    return()=>{alive=false;};
  },[projectId,protectionEnabled]);
  if(!protectionEnabled)return <ChildrensBookPublishedBook {...legacyProps}/>;
  if(error) return <div role="alert">{error}</div>;
  if(!loaded) return <p role="status">Loading published edition…</p>;
  return <ChildrensBookPublishedBook {...legacyProps}
    projectPlan={loaded.legacy?legacyProps.projectPlan:loaded.projectPlan}
    childrensBookAssets={loaded.legacy?legacyProps.childrensBookAssets:loaded.childrensBookAssets}/>;
}
